module.exports = __webpack_public_path__ + "static/media/credly.2acb0a18.svg";